// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e5591ded","608":"a09a55fd","880":"73f99316"}[chunkId] + ".chunk.js";
};